import React, { useState } from 'react';

/**
 * ShareButtons Component
 * Single button that uses native Web Share API with fallback to copy link
 */
export default function ShareButtons({ url, title, description, analytics }) {
  const [isCopied, setIsCopied] = useState(false);

  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const shareTitle = title || 'Check this out on Pink Wallet';
  const shareText = description || shareTitle;
  const emoji = '🩷🏳️‍⚧️🏳️‍🌈';

  const handleShare = async () => {
    // Check if Web Share API is available
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: `${shareText} ${emoji}`,
          url: shareUrl,
        });
        if (analytics) {
          analytics.trackInteraction('share_native', { url: shareUrl });
        }
      } catch (error) {
        // User cancelled or share failed
        if (error.name !== 'AbortError') {
          console.error('Share failed:', error);
        }
      }
    } else {
      // Fallback: copy link to clipboard
      try {
        await navigator.clipboard.writeText(shareUrl);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
        if (analytics) {
          analytics.trackInteraction('share_copy_link', { url: shareUrl });
        }
      } catch (error) {
        console.error('Failed to copy link:', error);
      }
    }
  };

  return (
    <div className="share-buttons mb-6">
      <button
        onClick={handleShare}
        className="btn btn-sm bg-brand-600 hover:bg-brand-700 text-white transition-colors w-full flex items-center gap-2 justify-center"
        title="Share this page"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        <span className="inline-block">{isCopied ? 'Link Copied!' : 'Share'}</span>
      </button>
    </div>
  );
}
